"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normaliseArrayOfCommunities = exports.getSuperSegmentColours = void 0;

var _helpers = require("../../helpers");

var getSuperSegmentColours = function getSuperSegmentColours(superSegments) {
  // return a key/value array of the community colours
  var values = {};

  if (superSegments.bySlug) {
    Object.values(superSegments.bySlug).map(function (superSegment) {
      return values[superSegment.id] = superSegment.color;
    });
  }

  return values;
}; // export const arrayOfObjectsOrder = (
//   array: Array<Object>,
//   key: string = 'id'
// ) => {
//   const order = [];
//   for (let i = 0; i < array.length; i++) {
//     order.push(array[i][key]);
//   }
//   return order;
// };


exports.getSuperSegmentColours = getSuperSegmentColours;

var normaliseArrayOfCommunities = function normaliseArrayOfCommunities(array, key) {
  if (key === void 0) {
    key = 'id';
  }

  return {
    bySlug: (0, _helpers.arrayToObject)(array, key),
    order: (0, _helpers.arrayOfObjectsOrder)(array, key)
  };
};

exports.normaliseArrayOfCommunities = normaliseArrayOfCommunities;